module.exports = __webpack_public_path__ + "img/zw.6b52ce1d.png";